import React from "react";
import styled from "styled-components";
import Images from "../../../assets/images/Images";

const StyledHeader = styled.div`
  align-items: center;
  background-color: #E4002B;
  box-shadow: 0 3em 6em #00000029;
  display: flex;
  height: 7vh;
  min-height: 60px;
  flex: 0 0 auto;
  flex-direction: row;

  & .hamburguer-menu {
    flex: 1 0 auto;
    height: 100%;

    & img {
      height: 100%;
    }
  }

  & .isotype-economics {
    height: 50%;
    flex: 0 0 auto;
    padding-left: 2%;
    padding-right: 5%;

    & img {
      height: 100%;
    }
  }
`;

interface HeaderProps {
  isSidebarOpen: boolean,
  setIsSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

const Header = ({ isSidebarOpen, setIsSidebarOpen }: HeaderProps) => {
  return (
    <StyledHeader>
      <div className='hamburguer-menu'>
        <img
          src={Images.menu}
          onClick={ () => setIsSidebarOpen(!isSidebarOpen) }
        />
      </div>
      <div className='isotype-economics'>
        <img src={Images.isotypeMapfreEconomics} />
      </div>
    </StyledHeader>
  );
};

export default Header;
